<template>
  <div class="page">
    <div class="row">
      <div class="flex md12 sm12">
          <sp-360-panel :title="$t('assistencia.RBE.RBE')" :footerText="$t('rodape.fonteData', {fonte: meta, data: dataRef})">
                <div class="flex-box">
                  <div class="row" style="padding-bottom:2rem">
                      <va-button-toggle
                        id="toggle-button"
                        outline small
                        v-model="toggleRBE"
                        :options="[{label:'Grafico', value: true}, {label:'Tabela', value: false}]"
                        color="info"
                        @input="!toggleRBE"
                      />
                  </div>
                    <sp360-chart :data="graficoRBE.data" type="vertical-bar" :options="graficoRBE.options" class="chart" v-if="toggleRBE"/>
                    <sp360-data-table id="tabelabeneficios" ref="tabelabeneficios"
                      :apiMode="false"
                      :data="tabelaRBE.dados"
                      :fields="tabelaRBE.campos"
                      :perPage="tabelaRBE.itemsPerPage"
                      noDataLabel="Selecione uma região."
                      v-if="!toggleRBE"
                    />
                </div>
          </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex md12 sm12">
          <sp-360-panel :title="$t('assistencia.RBE.PBF')" :footerText="$t('rodape.fonteData', {fonte: meta, data: dataRef})">
                <div class="flex-box">
                  <div class="row" style="padding-bottom:2rem">
                      <va-button-toggle
                        id="toggle-button"
                        outline small
                        v-model="togglePBF"
                        :options="[{label:'Grafico', value: true}, {label:'Tabela', value: false}]"
                        color="info"
                        @input="!togglePBF"
                      />
                  </div>
                    <sp360-chart :data="graficoPBF.data" type="vertical-bar" :options="graficoPBF.options" class="chart" v-if="togglePBF"/>
                    <sp360-data-table id="tabelabeneficios" ref="tabelabeneficios"
                      :apiMode="false"
                      :data="tabelaPBF.dados"
                      :fields="tabelaPBF.campos"
                      :perPage="tabelaPBF.itemsPerPage"
                      noDataLabel="Selecione uma região."
                      v-if="!togglePBF"
                    />
                </div>
          </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex md12 sm12">
          <sp-360-panel :title="$t('assistencia.RBE.RM')" :footerText="$t('rodape.fonteData', {fonte: meta, data: dataRef})">
                <div class="flex-box">
                  <div class="row" style="padding-bottom:2rem">
                      <va-button-toggle
                        id="toggle-button"
                        outline small
                        v-model="toggleRM"
                        :options="[{label:'Grafico', value: true}, {label:'Tabela', value: false}]"
                        color="info"
                        @input="!toggleRM"
                      />
                  </div>
                    <sp360-chart :data="graficoRM.data" type="vertical-bar" :options="graficoRM.options" class="chart" v-if="toggleRM"/>
                    <sp360-data-table id="tabelabeneficios" ref="tabelabeneficios"
                      :apiMode="false"
                      :data="tabelaRM.dados"
                      :fields="tabelaRM.campos"
                      :perPage="tabelaRM.itemsPerPage"
                      noDataLabel="Selecione uma região."
                      v-if="!toggleRM"
                    />
                </div>
          </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex md12 sm12">
          <sp-360-panel :title="tabela.titulo" :footerText="$t('rodape.fonteData', {fonte: meta, data: dataRef})">
              <div class="flex-box">
                <!-- <sp360-chart :data="graficoBarra.data" type="vertical-bar" :options="graficoBarra.options" class="chart"/> -->

                <sp360-chart :data="graficoBarraSub.data" type="vertical-bar" :options="graficoBarraSub.options" class="chart"/>
              </div>
              <div class="flex-box">
                <div class="flex lg3 sm12 md3">
                  <!-- <multiselect id="selectSubprefeituras" name="Subprefeituras" placeholder="Selecione uma Subprefeitura"
                  track-by="NOME" label="NOME" :value="subSel" :options="subs" :close-on-select="true" :show-labels="false"
                  @input="updateMultiSelect" /> -->
                </div>
              </div>
              <div class="flex-box">
                <!-- <sp-distritos v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP" :habilitarAnimacaoClique="true"/> -->
                <sp360-data-table id="tabelabeneficios" ref="tabelabeneficios"
                    :apiMode="false"
                    :data="tabela.dados"
                    :fields="tabela.campos"
                    :perPage="tabela.itemsPerPage"
                    noDataLabel="Selecione uma região."
                />
              </div>
          </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import _ from 'lodash'
import mapaDeCalor from '@/services/MapaDeCalor'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import CorUtils from '@/utils/CorUtils'
import Multiselect from 'vue-multiselect'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import SpMap from '@/components/maps/360-maps/SPMap.vue'
import SPMapaNomes from '@/utils/SPMapaNomes'
import SpDistritos from '@/components/maps/360-maps/SPDistritos'
import SPDistritosNomes from '@/utils/SPDistritosNomes'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360datatable from '../../ui/dataTable/sp360datatable.vue'

export default {
  name: 'renda-basica-emergencial',
  components: {
    SpMap,
    Multiselect,
    Sp360DataTable,
    Sp360Panel,
    SpDistritos,
    SPDistritosNomes,
    Sp360Chart,
    SPMapaNomes,
    Sp360datatable,
  },

  props: {
  },

  data () {
    return {
      meta: 'Bolsa Familia Julho de 2021',
      meta2: 'BPC Junho de 2021',
      meta3: 'Renda Minima Julho de 2021',
      meta4: 'Renda básica EmergencialDezembro de 2021 (referencia a folha do PBF dse setembro de 2020).',
      dataRef: new Date().toLocaleDateString('pt-BR'),

      retorno: [],
      graficoBarra: {
        data: {},
        options: {},
      },

      graficoBarraSub: {
        data: {},
        options: {},
      },

      graficoRBE: {
        data: {},
        options: {},
      },

      graficoPBF: {
        data: {},
        options: {},
      },

      graficoRM: {
        data: {},
        options: {},
      },

      toggleRBE: true,
      togglePBF: true,
      toggleRM: true,

      tabela: {
        dados: [],
        campos: [
          {
            name: 'subprefeitura',
            sortField: 'subprefeitura',
            title: this.$t('assistencia.RBE.tabela.subprefeitura'),
            width: '10%',
          },
          {
            name: 'Distrito',
            sortField: 'Distrito',
            title: this.$t('assistencia.RBE.tabela.distrito'),
            width: '10%',
          },
          {
            name: 'familiasBeneficiariasPBF',
            sortField: 'familiasBeneficiariasPBF',
            title: this.$t('assistencia.RBE.tabela.familiasBeneficiariasPBF'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'valorMedioPBF',
            sortField: 'valorMedioPBF',
            title: this.$t('assistencia.RBE.tabela.valorMedioPBF'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'valorTotalRepassadoPBF',
            sortField: 'valorTotalRepassadoPBF',
            title: this.$t('assistencia.RBE.tabela.valorTotalRepassadoPBF'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'familiasBeneficiariasRBE',
            sortField: 'familiasBeneficiariasRBE',
            title: this.$t('assistencia.RBE.tabela.familiasBeneficiariasRBE'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'valorMedioRBE',
            sortField: 'valorMedioRBE',
            title: this.$t('assistencia.RBE.tabela.valorMedioRBE'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'valorTotalRepassadoRBE',
            sortField: 'valorTotalRepassadoRBE',
            title: this.$t('assistencia.RBE.tabela.valorTotalRepassadoRBE'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'familiasBeneficiariasRM',
            sortField: 'familiasBeneficiariasRM',
            title: this.$t('assistencia.RBE.tabela.familiasBeneficiariasRM'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'valorMedioRM',
            sortField: 'valorMedioRM',
            title: this.$t('assistencia.RBE.tabela.valorMedioRM'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'valorTotalRepassadoRM',
            sortField: 'valorTotalRepassadoRM',
            title: this.$t('assistencia.RBE.tabela.valorTotalRepassadoRM'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'BPC_Idoso',
            sortField: 'BPC_Idoso',
            title: this.$t('assistencia.RBE.tabela.BPC_Idoso'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'valorMedioBPC_Idoso',
            sortField: 'valorMedioBPC_Idoso',
            title: this.$t('assistencia.RBE.tabela.valorMedioBPC_Idoso'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'valorRepassadoBPC_Idoso',
            sortField: 'valorRepassadoBPC_Idoso',
            title: this.$t('assistencia.RBE.tabela.valorRepassadoBPC_Idoso'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'BPC_Pcd',
            sortField: 'BPC_Pcd',
            title: this.$t('assistencia.RBE.tabela.BPC_Pcd'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'valorMedioBPC_Pcd',
            sortField: 'valorMedioBPC_Pcd',
            title: this.$t('assistencia.RBE.tabela.valorMedioBPC_Pcd'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
          {
            name: 'valorRepassadoBPC_Pcd',
            sortField: 'valorRepassadoBPC_Pcd',
            title: this.$t('assistencia.RBE.tabela.valorRepassadoBPC_Pcd'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR') },
            width: '4,93%',
          },
        ],
        sortFunctions: {
        },
        itemsPerPage: 10,
      },

      tabelaRBE: {
        dados: [],
        campos: [
          {
            name: 'subprefeitura',
            sortField: 'subprefeitura',
            title: this.$t('assistencia.RBE.tabela.subprefeitura'),
            width: '20%',
          },
          {
            name: 'Distrito',
            sortField: 'Distrito',
            title: this.$t('assistencia.RBE.tabela.distrito'),
            width: '20%',
          },
          {
            name: 'familiasBeneficiariasRBE',
            sortField: 'familiasBeneficiariasRBE',
            title: this.$t('assistencia.RBE.tabela.familiasBeneficiariasRBE'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) },
            width: '20%',
          },
          {
            name: 'valorMedioRBE',
            sortField: 'valorMedioRBE',
            title: this.$t('assistencia.RBE.tabela.valorMedioRBE'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) },
            width: '20%',
          },
          {
            name: 'valorTotalRepassadoRBE',
            sortField: 'valorTotalRepassadoRBE',
            title: this.$t('assistencia.RBE.tabela.valorTotalRepassadoRBE'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) },
            width: '20%',
          },
        ],
        sortFunctions: {
        },
        itemsPerPage: 10,
      },

      tabelaPBF: {
        dados: [],
        campos: [
          {
            name: 'subprefeitura',
            sortField: 'subprefeitura',
            title: this.$t('assistencia.RBE.tabela.subprefeitura'),
            width: '20%',
          },
          {
            name: 'Distrito',
            sortField: 'Distrito',
            title: this.$t('assistencia.RBE.tabela.distrito'),
            width: '20%',
          },
          {
            name: 'familiasBeneficiariasPBF',
            sortField: 'familiasBeneficiariasPBF',
            title: this.$t('assistencia.RBE.tabela.familiasBeneficiariasPBF'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) },
            width: '20%',
          },
          {
            name: 'valorMedioPBF',
            sortField: 'valorMedioPBF',
            title: this.$t('assistencia.RBE.tabela.valorMedioPBF'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) },
            width: '20%',
          },
          {
            name: 'valorTotalRepassadoPBF',
            sortField: 'valorTotalRepassadoPBF',
            title: this.$t('assistencia.RBE.tabela.valorTotalRepassadoPBF'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) },
            width: '20%',
          },
        ],
        sortFunctions: {
        },
        itemsPerPage: 10,
      },

      tabelaRM: {
        dados: [],
        campos: [
          {
            name: 'subprefeitura',
            sortField: 'subprefeitura',
            title: this.$t('assistencia.RBE.tabela.subprefeitura'),
            width: '20%',
          },
          {
            name: 'Distrito',
            sortField: 'Distrito',
            title: this.$t('assistencia.RBE.tabela.distrito'),
            width: '20%',
          },
          {
            name: 'familiasBeneficiariasRM',
            sortField: 'familiasBeneficiariasRM',
            title: this.$t('assistencia.RBE.tabela.familiasBeneficiariasRM'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) },
            width: '20%',
          },
          {
            name: 'valorMedioRBE',
            sortField: 'valorMedioRM',
            title: this.$t('assistencia.RBE.tabela.valorMedioRM'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) },
            width: '20%',
          },
          {
            name: 'valorTotalRepassadoRM',
            sortField: 'valorTotalRepassadoRM',
            title: this.$t('assistencia.RBE.tabela.valorTotalRepassadoRM'),
            callback: function (x) { return parseFloat(x).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) },
            width: '20%',
          },
        ],
        sortFunctions: {
        },
        itemsPerPage: 10,
      },

      cores: [],

    }
  },

  created () {
    Promise.all([
      this.$store.dispatch('assistenciaSocial/rendaBasicaEmergencial'),
    ]).then(resposta => {
      this.cores = CorUtils.getVetorCoresPorTom('medio')
      this.cc = '#f00' // CorUtils.getCorPorNomeSp360('verde-limao-medio')

      this.retorno = resposta
      this.tabela.dados = resposta[0]
      this.tabelaRBE.dados = resposta[0]
      this.tabelaPBF.dados = resposta[0]
      this.tabelaRM.dados = resposta[0]

      this.graficoBarra.options = this.getchartOptions('distritos', 'Familias Beneficiadas')
      this.graficoBarra.data = this.montarGraficoBarras(resposta[0], CorUtils.getVetorCoresPorTom('medio'))

      this.organizadoSUB = SPMapaNomes
      this.organizadoSUB.forEach(sub => {
        sub.itens = _.reduce(resposta[0], function (result, value, key) {
          if (value.subprefeitura === sub.nome) {
            result.BPC_Idoso += value.BPC_Idoso
            result.BPC_Pcd += value.BPC_Pcd
            result.familiasBeneficiariasPBF += parseFloat(value.familiasBeneficiariasPBF)
            result.familiasBeneficiariasRBE += parseFloat(value.familiasBeneficiariasRBE)
            result.familiasBeneficiariasRM += parseFloat(value.familiasBeneficiariasRM)
            result.valorMedioBPC_Idoso += parseFloat(value.valorMedioBPC_Idoso)
            result.valorMedioBPC_Pcd += parseFloat(value.valorMedioBPC_Pcd)
            result.valorMedioPBF += parseFloat(value.valorMedioPBF)
            result.valorMedioRBE += parseFloat(value.valorMedioRBE)
            result.valorMedioRM += parseFloat(value.valorMedioRM)
            result.count += 1
            result.valorRepassadoBPC_Idoso += parseFloat(value.valorRepassadoBPC_Idoso)
            result.valorRepassadoBPC_Pcd += parseFloat(value.valorRepassadoBPC_Pcd)
            result.valorTotalRepassadoPBF += parseFloat(value.valorTotalRepassadoPBF)
            result.valorTotalRepassadoRBE += parseFloat(value.valorTotalRepassadoRBE)
            result.valorTotalRepassadoRM += parseFloat(value.valorTotalRepassadoRM)
          }
          return result
        }, {
          BPC_Idoso: 0,
          BPC_Pcd: 0,
          familiasBeneficiariasPBF: 0,
          familiasBeneficiariasRBE: 0,
          familiasBeneficiariasRM: 0,
          valorMedioBPC_Idoso: 0,
          valorMedioBPC_Pcd: 0,
          valorMedioPBF: 0,
          valorMedioRBE: 0,
          valorMedioRM: 0,
          valorRepassadoBPC_Idoso: 0,
          valorRepassadoBPC_Pcd: 0,
          valorTotalRepassadoPBF: 0,
          valorTotalRepassadoRBE: 0,
          valorTotalRepassadoRM: 0,
          count: 0,
        })
      })

      this.naoLocalizados = _.remove(this.organizadoSUB, (e) => e.orgao === 'GERAL')
      // --
      this.graficoBarraSub.options = this.getchartOptionsSub(this.$t('assistencia.RBE.Subprefeitura'), this.$t('assistencia.RBE.familiasBeneficiadas'))
      this.graficoBarraSub.data = this.montarGraficoBarrasSub(this.organizadoSUB)
      // --
      this.graficoRBE.data = this.montarGraficoRBE(this.organizadoSUB, ['familiasBeneficiariasRBE', 'valorTotalRepassadoRBE', 'valorMedioRBE'], [this.cores[1], this.cores[3], this.cores[6]])
      this.graficoRBE.options = this.getchartOptionsRBE(this.$t('assistencia.RBE.Subprefeitura'), this.$t('assistencia.RBE.familiasBeneficiadas'))
      // --
      this.graficoPBF.data = this.montarGraficoRBE(this.organizadoSUB, ['familiasBeneficiariasPBF', 'valorTotalRepassadoPBF', 'valorMedioPBF'], [this.cores[4], this.cores[7], this.cores[9]])
      this.graficoPBF.options = this.getchartOptionsRBE(this.$t('assistencia.RBE.Subprefeitura'), this.$t('assistencia.RBE.familiasBeneficiadas'))
      // --
      this.graficoRM.data = this.montarGraficoRBE(this.organizadoSUB, ['familiasBeneficiariasRM', 'valorTotalRepassadoRM', 'valorMedioRM'], [this.cores[1], this.cores[3], this.cores[6]])
      this.graficoRM.options = this.getchartOptionsRBE(this.$t('assistencia.RBE.Subprefeitura'), this.$t('assistencia.RBE.familiasBeneficiadas'))
    })
  },

  methods: {
    montarGraficoBarras (dados, cores) {
      let palette = this.$store.getters.palette
      let chartData = {
        datasets: [],
        labels: [],
      }

      let dataset = {
        borderColor: palette.transparent,
        data: [],
        yAxisID: 'BarAxis',
        datalabels: {
          color: 'black',
          formatter: (value) => value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          anchor: 'end',
          rotation: -90,
          align: 'end',
        },
        categoryPercentage: 0.2,
        barPercentage: 1.0,
      }

      let PBF = _.cloneDeep(dataset)
      PBF.backgroundColor = cores.shift()
      PBF.label = 'PBF'

      let RM = _.cloneDeep(dataset)
      RM.backgroundColor = cores.shift()
      RM.label = 'RM'

      let RBE = _.cloneDeep(dataset)
      RBE.backgroundColor = cores.shift()
      RBE.label = 'RBE'

      let BPC_Idoso = _.cloneDeep(dataset)
      BPC_Idoso.backgroundColor = cores.shift()
      BPC_Idoso.label = 'BPC Idoso'

      let BPC_Pcd = _.cloneDeep(dataset)
      BPC_Pcd.backgroundColor = cores.shift()
      BPC_Pcd.label = 'BPC PCD'

      dados.forEach(el => {
        chartData.labels.push(el.Distrito)
        PBF.data.push(el.familiasBeneficiariasPBF)
        RBE.data.push(el.familiasBeneficiariasRBE)
        BPC_Idoso.data.push(el.BPC_Idoso)
        BPC_Pcd.data.push(el.BPC_Pcd)
        RM.data.push(el.familiasBeneficiariasRM)
      })

      chartData.datasets.push(PBF)
      chartData.datasets.push(RBE)
      chartData.datasets.push(BPC_Idoso)
      chartData.datasets.push(BPC_Pcd)
      chartData.datasets.push(RM)

      return chartData
    },

    montarGraficoBarrasSub (dados, keys) {
      let palette = this.$store.getters.palette
      let chartData = {
        datasets: [],
        labels: [],
      }

      let dataset = {
        backgroundColor: 'blue',
        borderColor: palette.transparent,
        data: [],
        yAxisID: 'BarAxis',
        datalabels: {
          color: 'black',
          formatter: (value) => value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          font: {
            weight: 'bold',
          },
          anchor: 'end',
          rotation: -90,
          align: 'end',
        },
      }

      let PBF = _.cloneDeep(dataset)
      PBF.backgroundColor = this.cores.shift()
      PBF.label = 'PBF'

      let RM = _.cloneDeep(dataset)
      RM.backgroundColor = this.cores.shift()
      RM.label = 'RM'

      let RBE = _.cloneDeep(dataset)
      RBE.backgroundColor = this.cores.shift()
      RBE.label = 'RBE'

      let BPC_Idoso = _.cloneDeep(dataset)
      BPC_Idoso.backgroundColor = this.cores.shift()
      BPC_Idoso.label = 'BPC Idoso'

      let BPC_Pcd = _.cloneDeep(dataset)
      BPC_Pcd.backgroundColor = this.cores.shift()
      BPC_Pcd.label = 'BPC PCD'

      dados.forEach(el => {
        chartData.labels.push(el.nome)
        PBF.data.push(el.itens.familiasBeneficiariasPBF)
        RM.data.push(el.itens.familiasBeneficiariasRM)
        RBE.data.push(el.itens.familiasBeneficiariasRBE)
        BPC_Idoso.data.push(el.itens.BPC_Idoso)
        BPC_Pcd.data.push(el.itens.BPC_Pcd)
      })

      chartData.datasets.push(PBF)
      chartData.datasets.push(RM)
      chartData.datasets.push(RBE)
      chartData.datasets.push(BPC_Idoso)
      chartData.datasets.push(BPC_Pcd)

      return chartData
    },

    montarGraficoRBE (dados, keys, cores) {
      let palette = this.$store.getters.palette
      let chartData = {
        datasets: [],
        labels: [],
      }

      let dataset = {
        backgroundColor: 'blue',
        borderColor: palette.transparent,
        data: [],
        yAxisID: 'BarAxis',
        datalabels: {
          color: 'black',
          formatter: (value) => value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          font: {
            weight: 'bold',
          },
          anchor: 'end',
          rotation: -90,
          align: 'start',
        },
      }

      let RBE = _.cloneDeep(dataset)
      RBE.backgroundColor = cores.shift()
      RBE.label = 'Familias Beneficiadas'
      RBE.fill = false
      RBE.borderColor = palette.transparent

      let RBE_repasse = _.cloneDeep(dataset)
      RBE_repasse.backgroundColor = cores.shift()
      RBE_repasse.fill = false
      RBE_repasse.borderColor = palette.transparent
      RBE_repasse.label = 'Valor total repasses'
      RBE_repasse.datalabels.formatter = (value) => 'R$ ' + value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })

      let RBE_media = _.cloneDeep(dataset)
      RBE_media.backgroundColor = this.cc
      RBE_media.borderColor = this.cc
      RBE_media.fill = false
      RBE_media.type = 'line'
      RBE_media.label = 'Valor médio'
      RBE_media.yAxisID = 'lineAxis'
      RBE_media.datalabels.display = false

      dados.forEach(el => {
        let nome = (el.nome === 'GERAL') ? 'NÃO LOCALIZADO' : el.nome
        chartData.labels.push(nome)
        RBE.data.push(el.itens[keys[0]])
        RBE_repasse.data.push(el.itens[keys[1]])
        RBE_media.data.push((el.itens[keys[2]] / el.itens.count))
      })

      chartData.datasets.push(RBE_media)
      chartData.datasets.push(RBE_repasse)
      chartData.datasets.push(RBE)

      return chartData
    },

    getchartOptions (xAxixLabel, yAxixLabel, chartData) {
      return {
        plugins: {
          datalabels: {
            font: {
              // weight: 'bold',
            },
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 50,
            bottom: 5,
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
        },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            scaleLabel: {
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          yAxes: [
            {
              id: 'BarAxis',
              stacked: true,
              position: 'left',
              type: 'logarithmic',
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: yAxixLabel,
              },
              ticks: {
                maxTicksLimit: 10,
                beginAtZero: true,
                autoSkip: false,
                callback: function (value, index, values) {
                  return MetodosGlobais.thousandSeparator(value)
                },
              },
            },
          ],
        },
      }
    },

    getchartOptionsSub (xAxixLabel, yAxixLabel, chartData) {
      return {
        plugins: {
          datalabels: {
            font: {
              // weight: 'bold',
            },
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 50,
            bottom: 5,
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
          },
        },
        responsive: true,

        scales: {
          xAxes: [{

            scaleLabel: {
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          yAxes: [
            {
              id: 'BarAxis',
              position: 'left',
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: yAxixLabel,
              },
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return MetodosGlobais.thousandSeparator(value)
                },
              },
            },

          ],
        },
      }
    },

    getchartOptionsRBE (xAxixLabel, yAxixLabel, chartData) {
      return {
        plugins: {
          datalabels: {
            font: {
              // weight: 'bold',
            },
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 50,
            bottom: 5,
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItems, data) {
              var title = ''
              var labels = data.labels
              var labelCount = labels ? labels.length : 0

              if (tooltipItems.length > 0) {
                var item = tooltipItems[0]
                if (item.label) {
                  title = item.label
                } else if (item.xLabel) {
                  title = item.xLabel
                } else if (labelCount > 0 && item.index < labelCount) {
                  title = labels[item.index]
                }
              }

              return title
            },
            label: function (tooltipItem, details) {
              let dataset = details.datasets[tooltipItem.datasetIndex]
              let currentValue = dataset.data[tooltipItem.index]
              return dataset.label + ': ' + currentValue.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
            },
          },
        },
        responsive: true,

        scales: {
          xAxes: [{
            scaleLabel: {
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          yAxes: [
            {
              id: 'BarAxis',
              type: 'logarithmic',
              position: 'left',
              beginAtZero: true,
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: yAxixLabel,
              },
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                callback: function (value, index, values) {
                  return MetodosGlobais.thousandSeparator(value)
                },
              },
            },
            {
              id: 'lineAxis',
              position: 'right',
              type: 'linear',
              beginAtZero: true,
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: yAxixLabel,
              },
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 7,
                callback: function (value, index, values) {
                  return 'R$ ' + value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
                },
              },
            },
          ],
        },
      }
    },

  },

}
</script>

<style lang="scss" scoped>
  #mapaSP {
    height: 30rem;
    color: #f00;
  }
  .chart{
    height: 30rem;
  }
</style>
